module.exports = __webpack_public_path__ + "img/lock-pattern.dcaf04d4.svg";